module.exports = "/assets/archetype-anger.webp"